// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"360":"fe8d1484","366":"1cf3bae6"}[chunkId] + ".css";
};